import { render, staticRenderFns } from "./DesignOppositionResponsibleList.vue?vue&type=template&id=3e3a4062&"
import script from "./DesignOppositionResponsibleList.vue?vue&type=script&lang=js&"
export * from "./DesignOppositionResponsibleList.vue?vue&type=script&lang=js&"
import style0 from "./DesignOppositionResponsibleList.vue?vue&type=style&index=0&id=3e3a4062&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports